import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";
import moment from "moment";
import _ from "lodash";
import { Form } from "react-bootstrap";

function FuseDatePicker(props) {
  const defaultDateFormat = "dd/MM/yyyy";
  const initValue = props?.value;

  const dateFormat = () => {
    if (props?.dateFormat != null) return props.dateFormat;
    return defaultDateFormat;
  };

  const inputComponent = useRef(null);
  const [isValidValue, setIsValidValue] = useState(false);

  useEffect(() => {
    updateValidity();
  });

  const _getValue = () => _parseDate(props?.value);
  const _getMinDate = () => _parseDate(props?.minDate);
  const _getMaxDate = () => _parseDate(props?.maxDate);

  const _parseDate = (dateStr) => {
    let dateValue = null;
    if (dateStr != null && dateStr !== "" && dateStr != 0) {
      let date = null;
      date = moment(dateStr, dateFormat().toUpperCase()).toDate();
      if (!isNaN(date.getTime())) dateValue = date;
      else {
        date = moment(dateStr).toDate();
        if (!isNaN(date.getTime())) dateValue = date;
      }
    }
    return dateValue;
  };

  const getErrorDescription = (err) => {
    if (err === "ValueMissing")
      return `This field is required. Please select a date.`;
    return `This field value is not valid`;
  };

  const _invalidErrorMessage = () => {
    let errors = getValidateErrors();
    if (errors.length > 0) return getErrorDescription(errors[0]);
    else return "";
  };

  const checkValid = () => getValidateErrors().length === 0;
  const getValidateErrors = () => {
    let errors = [];
    if (inputComponent?.current != null) {
      const { validity } = inputComponent.current;
      if (validity?.valueMissing === true) errors.push("ValueMissing");
      if (validity?.tooShort === true) errors.push("TooShort");
      if (validity?.tooLong === true) errors.push("TooLong");
      if (validity?.patternMismatch == true) errors.push("PatternMismatch");
      if (validity?.badInput === true) errors.push("BadInput");
      if (validity?.rangeOverflow === true) errors.push("RangeOverflow");
      if (validity?.rangeUnderflow === true) errors.push("RangeUnderflow");
      if (validity?.stepMismatch === true) errors.push("StepMismatch");
      if (validity?.typeMismatch === true) errors.push("TypeMismatch");
      // console.log(props.id, validity, errors);
    } // else if (props?.id) console.log("current == null ", props.id);
    return errors;
  };

  const updateValidity = () => {
    if (!inputComponent?.current) return;
    setIsValidValue(checkValid());
    inputComponent.current.setCustomValidity(_invalidErrorMessage());
  };

  const handleChange = (date) => {
    props?.onChange(date || "");
  };

  if (props?.editable === true) {
    return (
      <div className="col-sm-12" key={props?.id}>
        <Form.Control
          //type
          as={DatePicker}
          portalId={"portal-root"}
          //identifiers
          key="fuse-date-pick"
          //values
          disabled={props.disabled || false}
          // selected={selectedDate}
          selected={_getValue()}
          maxDate={_getMaxDate()}
          minDate={_getMinDate()}
          peekNextMonth={true}
          showMonthDropdown={true}
          showYearDropdown={true}
          dropdownMode="select"
          dateFormat={dateFormat()}
          placeholderText={props?.placeholder || dateFormat()}
          //settings
          isClearable={!props.disabled}
          //validation
          isInvalid={!isValidValue}
          //handlers
          onChange={handleChange}
        />
        <input
          //type
          ref={inputComponent}
          type=""
          className="col-sm-12"
          //identifiers
          id={props.id}
          //values
          value={_getValue() || ""}
          //settings
          tabIndex={-1}
          autoComplete="off"
          onChange={() => {}}
          style={{
            opacity: 0,
            height: 0,
            width: "100%",
            position: "absolute",
            top: "70%",
            left: "0",
          }}
          //validation
          required={props.required}
          //handlers
          onChange={() => {}}
        />
      </div>
    );
  } else {
    const selectedDate = _getValue();
    return (
      <div className="col-sm-12" key={props?.id}>
        {selectedDate
          ? moment(selectedDate).format(dateFormat().toUpperCase())
          : ""}
      </div>
    );
  }
}

FuseDatePicker.propTypes = {
  onChange: PropTypes.func.isRequired,
  editable: PropTypes.bool,
  id: PropTypes.string,
  value: PropTypes.any,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  maxDate: PropTypes.any,
  minDate: PropTypes.any,
};

export default FuseDatePicker;
